import { PostsQueryObject } from 'lib/core/services/magento/queries/posts'
import { Post } from 'lib/core/data/blog/post/types'

export interface CustomPost extends Post {
  meta_title?: string
}

export const blogPosts = {
  processor: (postsQueryObject: any, data: PostsQueryObject) => {
    postsQueryObject.posts.items.meta_title = data.posts.items.meta_title
  }
}
